// contentInfo Structure required 
/* contentInfo = {
  paisesDeRestriccion: ["es-AR"],
  node_locale: "es-CO",
  slug,
} */

import { removeDoubleSlash } from "../shared/utils/urlUril"

// conuntries info structure 
/* countries = {
  dominioDelPais: "https://www.nosotrasonline.com",
  codigoIcu: "es-CO"
} */

export const isContentInCountry = (content, country) =>
  content.paisesDeRestriccionDelProducto === null ||
  !content.paisesDeRestriccionDelProducto?.includes(country) ||
  false

export const createAlternates = ({ contentInfo, countries, category = "" }) => {
  // get country info
  const getCountryInfo = locale =>
    countries.find(country => country.codigoIcu === locale)

  // get article info
  const getInfoContentByCountry = locale =>
    contentInfo.find(content => isContentInCountry(content, locale))

  // create alternates
  const alternates = contentInfo?.reduce((acc, content) => {
    const localeSplited = content.node_locale.split("-")
    const country = localeSplited[1]
    const isValidCountry = isContentInCountry(content, country)

    if (isValidCountry) {
      const countryInfo = getCountryInfo(content.node_locale)

      acc.push({
        rel: "alternate",
        hrefLang: content.node_locale,
        href: `${countryInfo.dominioDelPais || ""}${removeDoubleSlash(category + content.slug)}`,
      })
    }
    return acc
  }, [])

  // set default Alternates
  const haveCO =
    alternates.find(alternate => alternate.hrefLang === "es-CO") || false

  const defaultCountry = haveCO
    ? getCountryInfo("es-CO")
    : getCountryInfo(alternates[0].hrefLang)

  const defaultContentInfo = getInfoContentByCountry(defaultCountry.codigoIcu)

  alternates.push({
    rel: "alternate",
    hrefLang: "x-default",
    href: `${defaultCountry.dominioDelPais}${removeDoubleSlash(category + defaultContentInfo.slug)}`,
  })

  return alternates || null
}
